import React, { useState, useEffect } from "react";

import Toast from "react-bootstrap/Toast";
import ToastContainer from "react-bootstrap/ToastContainer";

 export function ToastComponent(props) {
    
    const [params, setParams] = useState({});

    const handleClose = () => {
        props.closeToast();
    };

    useEffect(() => {
            if (props.params){
                setParams(JSON.parse(props.params));
            }

            setTimeout(() => {
                handleClose()
            }, 10000);
            // eslint-disable-next-line
            // eslint-disable-next-line
    }, [props]);

    return (
        <>
            {params.show ? (
                <ToastContainer className='bs-toast toast toast-placement-ex m-2 fade top-0 end-0 show'>
                    <Toast onClose={() => handleClose()} bg={params.color?.toLowerCase()}>
                        <Toast.Header>
                            <strong className='me-auto'>{params.title}</strong>
                        </Toast.Header>
                        <Toast.Body dangerouslySetInnerHTML={{ __html: params.body }}>
                            
                        </Toast.Body>
                    </Toast>
                </ToastContainer>
            ) : null}
        </>
    );
};